import { SOURCE_STATUSES } from "utils/constants/sourceStatus";

const byName = (left, right) =>
  String(left.name || "").localeCompare(String(right.name || ""), "fr", {
    sensitivity: "base",
  });

export const eligibleGuestSources = (sources) => {
  const seen = {};
  return (sources || [])
    .filter((source) => {
      if (!source || !source.id || seen[source.id]) return false;
      if (source.status !== SOURCE_STATUSES.ACTIVE) return false;
      seen[source.id] = true;
      return true;
    })
    .sort(byName);
};

export const guestLinkStep = (sources, confirmedId) => {
  const eligible = eligibleGuestSources(sources);
  if (eligible.length === 0) {
    return { kind: "create", sources: eligible, source: null };
  }
  if (eligible.length === 1) {
    return { kind: "link", sources: eligible, source: eligible[0] };
  }
  const source = eligible.find((item) => item.id === confirmedId) || null;
  return { kind: "choose", sources: eligible, source };
};
